import styled from "styled-components";
import { PressableProps } from "./pressable.props";

export const Pressable = styled.div<PressableProps>`
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  opacity: ${({ $disabled }) => ($disabled ? 0.7 : 1)};
`;
